module.exports = __webpack_public_path__ + "static/ruscitto-bc-box-79667e6f5ae09762443e04af54c28423.jpg";